/* vista-rapida — tocar un producto abre su tarjeta encima, sin salir de donde estabas.

   Alfredo, 2026-07-26: *"quiero que el cliente al presionar el producto, en lugar de que lleve a
   una nueva página, haya una tarjeta con el producto, poder hacer cambio de imágenes, y poder
   tener la opción de agregar imágenes rotatorias en 3D."*

   Tres decisiones que no son de gusto:

   · **El enlace sigue siendo un enlace.** Se intercepta el clic, no se reemplaza el `<a>`. Si
     este archivo no carga, si falla, o si alguien abre en pestaña nueva, el producto se abre
     como siempre. Una mejora que rompe la navegación cuando falla no es una mejora.

   · **El HTML lo hace Shopify, no este archivo.** Se pide `?view=tarjeta` y llega el fragmento
     ya armado —visor 3D incluido—. Reimplementar aquí el visor sería reescribir en JavaScript
     algo que el tema ya sabe hacer, y quedaría desactualizado a la primera.

   · **Se avisa que el 3D se gira.** Un modelo que nadie sabe que puede girarse es un adorno caro.
*/
(function () {
  "use strict";

  var CACHE = {};                       // el mismo producto no se pide dos veces
  var fondo, caja, cuerpo, ultimoFoco;

  function armar() {
    if (caja) return;
    fondo = document.createElement("div");
    fondo.className = "vr-fondo";
    fondo.hidden = true;
    fondo.addEventListener("click", cerrar);

    caja = document.createElement("div");
    caja.className = "vr-caja";
    caja.setAttribute("role", "dialog");
    caja.setAttribute("aria-modal", "true");
    caja.hidden = true;
    caja.innerHTML =
      '<button type="button" class="vr-cerrar" aria-label="Cerrar">✕</button>' +
      '<div class="vr-cuerpo"><div class="vr-cargando">Abriendo…</div></div>';
    caja.querySelector(".vr-cerrar").addEventListener("click", cerrar);

    document.body.appendChild(fondo);
    document.body.appendChild(caja);
    cuerpo = caja.querySelector(".vr-cuerpo");

    document.addEventListener("keydown", function (ev) {
      if (ev.key === "Escape" && !caja.hidden) cerrar();
    });
  }

  function abrir() {
    armar();
    ultimoFoco = document.activeElement;
    fondo.hidden = false;
    caja.hidden = false;
    document.body.classList.add("vr-abierta");
    caja.querySelector(".vr-cerrar").focus();
  }

  function cerrar() {
    if (!caja || caja.hidden) return;
    caja.hidden = true;
    fondo.hidden = true;
    document.body.classList.remove("vr-abierta");
    cuerpo.innerHTML = '<div class="vr-cargando">Abriendo…</div>';
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }

  /* Cambiar de imagen NO vuelve a pedir nada: los medios vienen todos en el HTML.
     Sirve para CUALQUIER galería —la de la tarjeta y la de la página del producto— porque las
     dos usan el mismo snippet. Tener dos implementaciones fue exactamente cómo la página del
     producto se quedó sin 3D mientras la tarjeta sí lo tenía. */
  function conectarGaleria(gal) {
    if (!gal || gal.dataset.lista) return;
    gal.dataset.lista = "1";
    var pre = gal.getAttribute("data-gal");
    var visor = gal.querySelector("#" + pre + "-visor");
    var plantilla = gal.querySelector("#" + pre + "-medios");
    if (!visor || !plantilla || !plantilla.content) return;
    var medios = Array.prototype.slice.call(plantilla.content.querySelectorAll("[data-i]"));
    gal.addEventListener("click", function (ev) {
      var b = ev.target.closest(".gal-mini");
      if (!b) return;
      var i = b.getAttribute("data-i");
      var m = medios.filter(function (x) { return x.getAttribute("data-i") === i; })[0];
      if (!m) return;
      visor.innerHTML = m.innerHTML;
      gal.querySelectorAll(".gal-mini").forEach(function (x) {
        x.classList.toggle("on", x === b);
        x.setAttribute("aria-selected", x === b ? "true" : "false");
      });
      // el 3D se gira con el dedo, pero eso hay que decirlo o nadie lo intenta
      visor.classList.remove("es3d");
      marcar3d(visor);            // al cambiar de medio, el aviso se recalcula desde cero
    });
    marcar3d(visor);
  }

  /* El aviso «gíralo» aparece cuando el modelo YA está cargado, no antes. Medido: puesto al
     cargar la página, la cuenta atrás corría mientras el modelo todavía descargaba y el aviso se
     apagaba antes de que hubiera nada que girar — el cliente no llegaba a verlo nunca. Y se ata
     al VISOR, no a la miniatura: un producto con un solo modelo no tiene tira de miniaturas. */
  function marcar3d(visor) {
    var mv = visor.querySelector("model-viewer");
    if (!mv) { visor.classList.remove("es3d"); return; }
    var ya = function () { visor.classList.add("es3d"); };
    if (mv.loaded) ya();
    else {
      mv.addEventListener("load", ya, {once: true});
      setTimeout(ya, 9000);          // si el modelo tarda de más, el aviso sale igual
    }
  }

  function conectarMedios(raiz) {
    raiz.querySelectorAll("[data-gal]").forEach(conectarGaleria);
  }

  // la galería de la PÁGINA del producto no pasa por la tarjeta: se conecta al cargar
  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-gal]").forEach(conectarGaleria);
  });

  /* Cambiar de opción cambia precio y disponibilidad sin recargar. */
  function conectarVariantes(raiz) {
    var datos = raiz.querySelector("#vr-variantes");
    var forma = raiz.querySelector(".vr-forma");
    if (!datos || !forma) return;
    var variantes;
    try { variantes = JSON.parse(datos.textContent); } catch (e) { return; }
    forma.addEventListener("change", function () {
      var elegidas = Array.prototype.map.call(
        forma.querySelectorAll("select[data-opcion]"), function (s) { return s.value; });
      var v = variantes.filter(function (x) {
        return elegidas.every(function (val, i) { return x.options[i] === val; });
      })[0];
      if (!v) return;
      var id = forma.querySelector('input[name="id"]');
      if (id) id.value = v.id;
      var precio = raiz.querySelector(".vr-precio");
      if (precio && window.Shopify && window.Shopify.formatMoney) {
        precio.textContent = window.Shopify.formatMoney(v.price);
      }
      var boton = forma.querySelector('button[type="submit"]');
      if (boton) {
        boton.disabled = !v.available;
        if (!v.available) boton.textContent = "Agotado";
      }
    });
  }

  async function mostrar(url) {
    abrir();
    try {
      var html = CACHE[url];
      if (!html) {
        var r = await fetch(url + (url.indexOf("?") >= 0 ? "&" : "?") + "view=tarjeta");
        if (!r.ok) throw new Error("no");
        html = await r.text();
        CACHE[url] = html;
      }
      cuerpo.innerHTML = html;
      conectarMedios(cuerpo);
      conectarVariantes(cuerpo);
    } catch (e) {
      // Si la tarjeta no se puede armar, se va a la página del producto: nunca se deja al
      // cliente mirando un hueco.
      window.location.href = url;
    }
  }

  /* ── LA SEGUNDA CAPA: EL RESTO DE LA INFORMACIÓN ────────────────────────────────────────────
     Alfredo, 2026-08-07: *"en lugar de llevar a la página del producto, quiero que abra otra capa
     para ver toda la información restante, dando click en la descripción"*.

     Va ENCIMA de la vista rápida y no la sustituye: quien lee la descripción larga sigue
     decidiendo sobre ese producto, y devolverle el carrito y las opciones al cerrar es lo que
     hace que leer no cueste volver a empezar.

     El texto completo ya viaja en la tarjeta (dentro de un <template>), así que abrir no cuesta
     otro viaje ni un parpadeo. Se cierra con Escape, con la ✕ y tocando fuera, y el foco vuelve
     a la descripción: quien navega con teclado no puede quedarse dentro de un cuadro cerrado. */
  var masFoco = null;
  function cierraMas() {
    var m = document.querySelector(".vr-mas");
    if (m) m.parentNode.removeChild(m);
    if (masFoco) { try { masFoco.focus(); } catch (e) {} masFoco = null; }
  }
  function abreMas(boton) {
    var tarjeta = boton.closest(".vr") || boton.parentNode;
    var plantilla = tarjeta.querySelector(".vr-desc-full");
    var titulo = (tarjeta.querySelector(".vr-titulo, h1, h2") || {}).textContent || "";
    cierraMas();
    masFoco = boton;
    var m = document.createElement("div");
    m.className = "vr-mas";
    m.innerHTML = '<div class="vr-mas-fondo"></div>'
      + '<div class="vr-mas-caja" role="dialog" aria-modal="true">'
      + '<button type="button" class="vr-mas-x" aria-label="Cerrar">✕</button>'
      + '<h3></h3><div class="vr-mas-cuerpo"></div>'
      + "</div>";
    // El título como TEXTO y la descripción como el HTML que ya venía de Shopify: escribir el
    // título con innerHTML metería en la página cualquier cosa que traiga el nombre del producto.
    m.querySelector("h3").textContent = titulo.trim();
    var cuerpo2 = m.querySelector(".vr-mas-cuerpo");
    if (plantilla) cuerpo2.appendChild(plantilla.content.cloneNode(true));
    document.body.appendChild(m);
    m.querySelector(".vr-mas-x").addEventListener("click", cierraMas);
    m.querySelector(".vr-mas-fondo").addEventListener("click", cierraMas);
    document.addEventListener("keydown", function esc(ev) {
      if (ev.key !== "Escape") return;
      document.removeEventListener("keydown", esc);
      ev.stopPropagation();          // no cierre TAMBIÉN la vista rápida de debajo
      cierraMas();
    });
    try { m.querySelector(".vr-mas-x").focus(); } catch (e) {}
  }

  document.addEventListener("click", function (ev) {
    // `data-vr-desc` y no `data-mas`: aquel nombre ya era el «+1 / −1» del cajón del carrito, y
    // como los dos oyen en todo el documento, subir la cantidad abría también esta ventana —
    // vacía, porque ahí no hay descripción que enseñar (Alfredo, 2026-08-11).
    var mas = ev.target.closest && ev.target.closest("[data-vr-desc]");
    if (mas) { ev.preventDefault(); abreMas(mas); return; }
    var a = ev.target.closest('a[href*="/products/"]');
    if (!a) return;
    if (a.closest(".vr-caja")) return;                       // el enlace de «ver todo» sí navega
    if (ev.metaKey || ev.ctrlKey || ev.shiftKey || ev.button !== 0) return;  // pestaña nueva
    if (a.getAttribute("target") === "_blank") return;
    if (a.hasAttribute("data-sin-tarjeta")) return;
    ev.preventDefault();
    mostrar(a.getAttribute("href").split("?")[0]);
  });
})();
